// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__SW70r","checkbox":"ThemeToggle_checkbox__9Ap0U","label":"ThemeToggle_label__+yChD","sun":"ThemeToggle_sun__BBlaC","moon":"ThemeToggle_moon__9GUUM"};